module.exports = __webpack_public_path__ + "img/Hubic.835740f2.png";